<template>
  <v-row dense>
    <v-col cols="12" :sm="fullWidth ? '12' : '4'">
      <span class="caption font-weight-bold">Depósito</span>
      <div :class="`${textClass}`">
        {{ formData.ARMAZEM | truncate(45) | naoInformado }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    textClass: {
      type: String,
      default: '',
    },
  },
};
</script>
